import { createEditorSelectionWithAllRelatedTrackChangesElements, findNextPreviousNonAdjacentChanges } from "./findNextPreviousChange";

/**
 * 
 * @param {*} editor 
 * @param {*} moduleInstance 
 * @param {String} direction "next" | "previous"
 */
export function triggerCommentsReload(editor, moduleInstance, direction) {
  var _moduleInstance$curre;
  const currentPopoverChangeElements = ((_moduleInstance$curre = moduleInstance.currentPopover) === null || _moduleInstance$curre === void 0 ? void 0 : _moduleInstance$curre.changeElements) || [];
  const nonAdjacentChanges = findNextPreviousNonAdjacentChanges(editor, currentPopoverChangeElements);
  const nextPreviousChangeElementToUse = nonAdjacentChanges["".concat(direction, "PopoverChangeElement")];
  const changeElementToUse = nextPreviousChangeElementToUse || editor.getBody().querySelector('TrackChanges-Highlight');
  if (changeElementToUse) {
    moduleInstance.createPopover(editor, changeElementToUse);
    const editorSelectionForComments = createEditorSelectionWithAllRelatedTrackChangesElements(editor, changeElementToUse);
    editor.fire('Comments:triggerChangeSelectedCommentSpanId', {
      payload: {
        cursorSelection: editorSelectionForComments
      }
    });
  }
}